import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Skeleton, SkeletonLine } from '@one-thd/sui-atomic-components';

export const ListHeaderSkeleton = ({ isMobile }) => {
  const headerClasses = classNames(
    'sui-w-full',
    {
      'sui-py-6 sui-mb-2': !isMobile,
      'sui-py-6': isMobile
    });
  return (
    <div className={headerClasses}>
      <Skeleton
        disablePadding
        orientation="horizontal"
        PaperProps={{
          className: 'sui-w-full',
          variant: 'shadow'
        }}
      >
        <SkeletonLine
          className="sui-flex sui-flex-col sui-gap-6 sui-w-full"
          numberOfLines={isMobile ? 4 : 3}
        />
      </Skeleton>
    </div>
  );
};

ListHeaderSkeleton.displayName = 'ProductList-ListHeaderSkeleton';

ListHeaderSkeleton.propTypes = {
  isMobile: PropTypes.bool.isRequired
};
